import { createContext, useState, useContext, useEffect } from "react";

const UserContext = createContext();

const UserProvider = ({ children }) => {
  const [user, setUser] = useState(() => initialUserData());

  function initialUserData() {
    return JSON.parse(localStorage.getItem("portfolio-theme")) ?? { isDark: false };
  }

  useEffect(() => {
    localStorage.setItem("portfolio-theme", JSON.stringify(user));
  }, [user]);

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};

const useUser = () => useContext(UserContext);

export { useUser, UserProvider };
